import { render, staticRenderFns } from "./TestingChange.vue?vue&type=template&id=728009d8"
import script from "./TestingChange.vue?vue&type=script&lang=ts"
export * from "./TestingChange.vue?vue&type=script&lang=ts"
import style0 from "./TestingChange.vue?vue&type=style&index=0&id=728009d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports